export default "__VITE_ASSET__5712dfc9__"